import * as Types from '../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import { PersonDetailDataFragmentDoc } from '../editor.generated';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type CustomerQueryVariables = Types.Exact<{
  id: Types.Scalars['UUID'];
}>;

export type CustomerQuery = {
  __typename?: 'Query';
  person: { __typename?: 'Person'; id: any };
};

export type UpdateCustomerMutationVariables = Types.Exact<{
  userInput: Types.CustomerInput;
  personInput: Types.PersonInput;
  id: Types.Scalars['UUID'];
}>;

export type UpdateCustomerMutation = {
  __typename?: 'Mutation';
  adminEditCustomer: {
    __typename?: 'Person';
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    id: any;
    createdAt: any;
    title?: string | null;
    gender?: Types.Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    inquiries: Array<{
      __typename?: 'Inquiry';
      id: any;
      createdAt: any;
      status: Types.InquiryStatus;
      assignee?: {
        __typename?: 'Administrator';
        id: any;
        fullName: string;
      } | null;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
  };
};

export type CreateCustomerMutationVariables = Types.Exact<{
  userInput: Types.CustomerInput;
  personInput: Types.PersonInput;
}>;

export type CreateCustomerMutation = {
  __typename?: 'Mutation';
  adminCreateCustomer: {
    __typename?: 'Person';
    internalNotes?: string | null;
    enterpriseIds?: Array<any> | null;
    id: any;
    createdAt: any;
    title?: string | null;
    gender?: Types.Gender | null;
    firstName?: string | null;
    lastName?: string | null;
    anonymizedAt?: any | null;
    employments: Array<{
      __typename?: 'Employment';
      id: any;
      description?: string | null;
      companyId: any;
      company: { __typename?: 'Company'; id: any; name: string };
    }>;
    enterprises: Array<{ __typename?: 'Enterprise'; id: any; name: string }>;
    user?:
      | {
          __typename?: 'Administrator';
          roleIds?: Array<any> | null;
          isBot: boolean;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          roles: Array<{ __typename?: 'Role'; id: any; name: Types.RoleType }>;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Customer';
          invoiceEmail?: string | null;
          customerNumber?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          orders: Array<{
            __typename?: 'Order';
            id: any;
            createdAt: any;
            total: number;
          }>;
          bookings: Array<
            | {
                __typename?: 'CourseModuleBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseModule: {
                  __typename?: 'CourseModule';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  courseUnit: {
                    __typename?: 'CourseUnit';
                    id: any;
                    course: {
                      __typename?: 'Course';
                      id: any;
                      title: string;
                      verboseTitle?: string | null;
                      abbreviation: string;
                    };
                  };
                };
              }
            | {
                __typename?: 'CourseUnitBooking';
                kind: Types.BookingKind;
                id: any;
                createdAt: any;
                courseUnit: {
                  __typename?: 'CourseUnit';
                  id: any;
                  title?: string | null;
                  sku: string;
                  startDate: any;
                  endDate: any;
                  dateUncertain: boolean;
                  withTime: boolean;
                  online: boolean;
                  correspondenceCourse: boolean;
                  location?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  secondaryLocation?: {
                    __typename?: 'Location';
                    id: any;
                    commonName: string;
                  } | null;
                  course: {
                    __typename?: 'Course';
                    id: any;
                    title: string;
                    verboseTitle?: string | null;
                    abbreviation: string;
                  };
                };
              }
          >;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | {
          __typename?: 'Teacher';
          jobTitle?: string | null;
          subjectArea?: string | null;
          slug?: string | null;
          id: any;
          username?: string | null;
          fullName: string;
          primaryEmail?: string | null;
          status: Types.UserStatus;
          description?: string | null;
          image?: {
            __typename?: 'FilesystemFile';
            id: any;
            url: string;
          } | null;
        }
      | null;
    contactProperties: Array<{
      __typename?: 'ContactProperty';
      id: any;
      key: Types.ContactPropertyKey;
      value: string;
    }>;
    inquiries: Array<{
      __typename?: 'Inquiry';
      id: any;
      createdAt: any;
      status: Types.InquiryStatus;
      assignee?: {
        __typename?: 'Administrator';
        id: any;
        fullName: string;
      } | null;
    }>;
    address: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
    invoiceAddress: {
      __typename?: 'Address';
      company?: string | null;
      contactPerson?: string | null;
      streetAndNumber?: string | null;
      postalCode?: string | null;
      city?: string | null;
      country?: string | null;
      other?: string | null;
    };
  };
};

export const CustomerDocument = gql`
  query customer($id: UUID!) {
    person(id: $id) {
      ... on PersonInterface {
        id
      }
    }
  }
`;
export type CustomerComponentProps = Omit<
  ApolloReactComponents.QueryComponentOptions<
    CustomerQuery,
    CustomerQueryVariables
  >,
  'query'
> &
  ({ variables: CustomerQueryVariables; skip?: boolean } | { skip: boolean });

export const CustomerComponent = (props: CustomerComponentProps) => (
  <ApolloReactComponents.Query<CustomerQuery, CustomerQueryVariables>
    query={CustomerDocument}
    {...props}
  />
);

/**
 * __useCustomerQuery__
 *
 * To run a query within a React component, call `useCustomerQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCustomerQuery(
  baseOptions: Apollo.QueryHookOptions<CustomerQuery, CustomerQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CustomerQuery, CustomerQueryVariables>(
    CustomerDocument,
    options,
  );
}
export function useCustomerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CustomerQuery,
    CustomerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<CustomerQuery, CustomerQueryVariables>(
    CustomerDocument,
    options,
  );
}
export type CustomerQueryHookResult = ReturnType<typeof useCustomerQuery>;
export type CustomerLazyQueryHookResult = ReturnType<
  typeof useCustomerLazyQuery
>;
export type CustomerQueryResult = Apollo.QueryResult<
  CustomerQuery,
  CustomerQueryVariables
>;
export const UpdateCustomerDocument = gql`
  mutation updateCustomer(
    $userInput: CustomerInput!
    $personInput: PersonInput!
    $id: UUID!
  ) {
    adminEditCustomer(
      userInput: $userInput
      personInput: $personInput
      id: $id
    ) {
      ...PersonDetailData
    }
  }
  ${PersonDetailDataFragmentDoc}
`;
export type UpdateCustomerMutationFn = Apollo.MutationFunction<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>;
export type UpdateCustomerComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >,
  'mutation'
>;

export const UpdateCustomerComponent = (
  props: UpdateCustomerComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >
    mutation={UpdateCustomerDocument}
    {...props}
  />
);

/**
 * __useUpdateCustomerMutation__
 *
 * To run a mutation, you first call `useUpdateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomerMutation, { data, loading, error }] = useUpdateCustomerMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      personInput: // value for 'personInput'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateCustomerMutation,
    UpdateCustomerMutationVariables
  >(UpdateCustomerDocument, options);
}
export type UpdateCustomerMutationHookResult = ReturnType<
  typeof useUpdateCustomerMutation
>;
export type UpdateCustomerMutationResult =
  Apollo.MutationResult<UpdateCustomerMutation>;
export type UpdateCustomerMutationOptions = Apollo.BaseMutationOptions<
  UpdateCustomerMutation,
  UpdateCustomerMutationVariables
>;
export const CreateCustomerDocument = gql`
  mutation createCustomer(
    $userInput: CustomerInput!
    $personInput: PersonInput!
  ) {
    adminCreateCustomer(userInput: $userInput, personInput: $personInput) {
      ...PersonDetailData
    }
  }
  ${PersonDetailDataFragmentDoc}
`;
export type CreateCustomerMutationFn = Apollo.MutationFunction<
  CreateCustomerMutation,
  CreateCustomerMutationVariables
>;
export type CreateCustomerComponentProps = Omit<
  ApolloReactComponents.MutationComponentOptions<
    CreateCustomerMutation,
    CreateCustomerMutationVariables
  >,
  'mutation'
>;

export const CreateCustomerComponent = (
  props: CreateCustomerComponentProps,
) => (
  <ApolloReactComponents.Mutation<
    CreateCustomerMutation,
    CreateCustomerMutationVariables
  >
    mutation={CreateCustomerDocument}
    {...props}
  />
);

/**
 * __useCreateCustomerMutation__
 *
 * To run a mutation, you first call `useCreateCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomerMutation, { data, loading, error }] = useCreateCustomerMutation({
 *   variables: {
 *      userInput: // value for 'userInput'
 *      personInput: // value for 'personInput'
 *   },
 * });
 */
export function useCreateCustomerMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateCustomerMutation,
    CreateCustomerMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateCustomerMutation,
    CreateCustomerMutationVariables
  >(CreateCustomerDocument, options);
}
export type CreateCustomerMutationHookResult = ReturnType<
  typeof useCreateCustomerMutation
>;
export type CreateCustomerMutationResult =
  Apollo.MutationResult<CreateCustomerMutation>;
export type CreateCustomerMutationOptions = Apollo.BaseMutationOptions<
  CreateCustomerMutation,
  CreateCustomerMutationVariables
>;
